var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6663 6.95C21.0262 4.77999 19.2162 2.97 17.0462 2.33C15.3962 1.85 14.2563 1.89 13.4663 2.48C12.5163 3.19 12.4062 4.47 12.4062 5.38V7.87C12.4062 10.33 13.5262 11.58 15.7262 11.58H18.5963C19.4963 11.58 20.7863 11.47 21.4963 10.52C22.1062 9.74 22.1562 8.6 21.6663 6.95Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9075 13.36C18.6475 13.06 18.2675 12.89 17.8775 12.89H14.2975C12.5375 12.89 11.1075 11.46 11.1075 9.7V6.12C11.1075 5.73 10.9375 5.35 10.6375 5.09C10.3475 4.83 9.94746 4.71 9.56746 4.76C7.21746 5.06 5.05746 6.35 3.64746 8.29C2.22746 10.24 1.70746 12.62 2.15746 15C2.80746 18.44 5.55746 21.19 9.00746 21.84C9.55746 21.95 10.1075 22 10.6575 22C12.4675 22 14.2175 21.44 15.7075 20.35C17.6475 18.94 18.9375 16.78 19.2375 14.43C19.2875 14.04 19.1675 13.65 18.9075 13.36Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/Graph.2358ebb46a569de03565f133a61d50ee.svg";
export { ForwardRef as ReactComponent };